import EventCard from "./event_card";

export default EventCard;
